import { ALVEOLAR_WATER_VAPOR_BAR, SURFACE_PRESSURE_BAR } from "../physics/pressure.js";
import type { TissueSnapshot } from "../types.js";
import { N_COMPARTMENTS } from "./constants.js";

export const SURFACE_AIR_FN2 = 0.79;

export function initSurfaceEquilibrium(): TissueSnapshot {
  const surfaceN2 = (SURFACE_PRESSURE_BAR - ALVEOLAR_WATER_VAPOR_BAR) * SURFACE_AIR_FN2;
  return { pN2: new Array(N_COMPARTMENTS).fill(surfaceN2) };
}

export function cloneTissues(t: TissueSnapshot): TissueSnapshot {
  return { pN2: [...t.pN2] };
}
